 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}
 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"runtime": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"calendar-calendar-module":"calendar-calendar-module","color-palette-color-palette-module":"color-palette-color-palette-module","default~cards-cards-module~charts-charts-module":"default~cards-cards-module~charts-charts-module","cards-cards-module":"cards-cards-module","default~charts-charts-module~dashboard-dashboard-module~pages-full-pages-full-pages-module":"default~charts-charts-module~dashboard-dashboard-module~pages-full-pages-full-pages-module","dashboard-dashboard-module":"dashboard-dashboard-module","default~charts-charts-module~tables-tables-module":"default~charts-charts-module~tables-tables-module","charts-charts-module":"charts-charts-module","pages-full-pages-full-pages-module":"pages-full-pages-full-pages-module","tables-tables-module":"tables-tables-module","default~chat-chat-module~chat-ngrx-chat-ngrx-module~player-player-module":"default~chat-chat-module~chat-ngrx-chat-ngrx-module~player-player-module","chat-chat-module":"chat-chat-module","chat-ngrx-chat-ngrx-module":"chat-ngrx-chat-ngrx-module","player-player-module":"player-player-module","default~components-ui-components-module~inbox-inbox-module":"default~components-ui-components-module~inbox-inbox-module","default~components-ui-components-module~ui-kit-ui-kit-module":"default~components-ui-components-module~ui-kit-ui-kit-module","components-ui-components-module":"components-ui-components-module","inbox-inbox-module":"inbox-inbox-module","ui-kit-ui-kit-module":"ui-kit-ui-kit-module","default~data-tables-data-tables-module~modules-accounts-account-pages-account-module~modules-account~c9c20e35":"default~data-tables-data-tables-module~modules-accounts-account-pages-account-module~modules-account~c9c20e35","common":"common","modules-accounts-accountgroup-pages-accountgroup-module":"modules-accounts-accountgroup-pages-accountgroup-module","modules-producthsncode-producthsncode-module":"modules-producthsncode-producthsncode-module","data-tables-data-tables-module":"data-tables-data-tables-module","default~modules-accounts-account-pages-account-module~modules-accounts-accounthead-pages-accounthead~bad02eb2":"default~modules-accounts-account-pages-account-module~modules-accounts-accounthead-pages-accounthead~bad02eb2","modules-accounts-accounthead-pages-accounthead-module":"modules-accounts-accounthead-pages-accounthead-module","default~modules-accounts-account-pages-account-module~modules-order-invoice-order-invoice-module~mod~6114afa8":"default~modules-accounts-account-pages-account-module~modules-order-invoice-order-invoice-module~mod~6114afa8","modules-stock-stock-module":"modules-stock-stock-module","default~modules-accounts-account-pages-account-module~modules-order-invoice-order-invoice-module~mod~b6748b43":"default~modules-accounts-account-pages-account-module~modules-order-invoice-order-invoice-module~mod~b6748b43","modules-order-invoice-order-invoice-module":"modules-order-invoice-order-invoice-module","modules-transfer-Invoice-transfer-invoice-module":"modules-transfer-Invoice-transfer-invoice-module","default~modules-accounts-account-pages-account-module~modules-purchase-purchase-module~modules-purch~a87db281":"default~modules-accounts-account-pages-account-module~modules-purchase-purchase-module~modules-purch~a87db281","modules-user-user-module":"modules-user-user-module","default~modules-accounts-account-pages-account-module~modules-purchase-purchase-module~modules-purch~9a903dbf":"default~modules-accounts-account-pages-account-module~modules-purchase-purchase-module~modules-purch~9a903dbf","modules-purchase-purchase-module":"modules-purchase-purchase-module","modules-purchasereturn-purchase-return-module":"modules-purchasereturn-purchase-return-module","modules-sale-sale-module":"modules-sale-sale-module","modules-sales-sales-module":"modules-sales-sales-module","modules-salesreturn-salesreturn-module":"modules-salesreturn-salesreturn-module","modules-accounts-account-pages-account-module":"modules-accounts-account-pages-account-module","modules-reports-reports-module":"modules-reports-reports-module","default~modules-product-product-module~modules-productoption-productoption-module":"default~modules-product-product-module~modules-productoption-productoption-module","modules-product-product-module":"modules-product-product-module","modules-productoption-productoption-module":"modules-productoption-productoption-module","modules-categories-categories-module":"modules-categories-categories-module","modules-permission-permission-module":"modules-permission-permission-module","modules-roles-roles-module":"modules-roles-roles-module","modules-store-store-module":"modules-store-store-module","forms-forms-module":"forms-forms-module","maps-maps-module":"maps-maps-module","pages-content-pages-content-pages-module":"pages-content-pages-content-pages-module","taskboard-ngrx-taskboard-ngrx-module":"taskboard-ngrx-taskboard-ngrx-module","taskboard-taskboard-module":"taskboard-taskboard-module"}[chunkId]||chunkId) + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							var error = new Error('Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')');
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
